
export default class Kiosk{
    constructor(params){
        this.name = params.point.name;
        this.id =params.id;
        this.locationId =params.locationId;
        this.coordinates = [params.x,params.y];

    }
}